import { motion } from 'framer-motion';
import { Mountain, Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="bg-[#0B111E] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-[#F95738] to-[#38BDF8] rounded-lg flex items-center justify-center">
                <Mountain className="w-7 h-7 text-white" />
              </div>
              <div>
                <div className="text-xl font-bold text-white">Roof Painters</div>
                <div className="text-xs text-[#38BDF8] font-medium tracking-widest uppercase">
                  Blue Mountains
                </div>
              </div>
            </div>
            <p className="text-[#94A3B8] text-sm leading-relaxed mb-6">
              Professional roof painting and restoration services for the Blue Mountains region. 
              Transforming roofs with quality and care since 1999.
            </p>
            <div className="flex gap-4">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <motion.a
                  key={i}
                  href="#"
                  whileHover={{ scale: 1.1, y: -2 }}
                  className="w-10 h-10 rounded-full glass flex items-center justify-center text-[#94A3B8] hover:text-[#38BDF8] transition-colors"
                >
                  <Icon className="w-5 h-5" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Services', 'Reviews', 'Service Areas', 'Get Quote'].map((link) => (
                <li key={link}>
                  <a 
                    href={`#${link.toLowerCase().replace(' ', '-')}`}
                    className="text-[#94A3B8] hover:text-[#38BDF8] transition-colors text-sm"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              {[
                'Roof Painting',
                'Roof Restoration',
                'Colorbond Roofing',
                'Tile Repairs',
                'Gutter Cleaning',
                'Pressure Washing'
              ].map((service) => (
                <li key={service}>
                  <a 
                    href="#services"
                    className="text-[#94A3B8] hover:text-[#38BDF8] transition-colors text-sm"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:0400000000"
                  className="flex items-center gap-3 text-[#94A3B8] hover:text-[#38BDF8] transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  <span>0400 000 000</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@roofpaintersbluemountains.com.au"
                  className="flex items-center gap-3 text-[#94A3B8] hover:text-[#38BDF8] transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  <span className="text-sm">info@roofpaintersbluemountains.com.au</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#94A3B8]">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  Serving Katoomba, Leura, Springwood & all Blue Mountains suburbs
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#94A3B8]">
            © {currentYear} Roof Painters Blue Mountains. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-[#94A3B8] hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-[#94A3B8] hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
